import { call, put, takeLatest } from "redux-saga/effects";
import { orderHistoryLatestServiceInit, orderHistoryLatestServiceFailure, orderHistoryLatestServiceSuccess } from "./OrderHistoryLatestSlice";
import { _API_ENDPOINT, LOCALSESSIONDATAKEYS, SUCCESS } from "../../constants/AppConstants"
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { handleError } from "../SagaError";
import i18next from "i18next";
import { _CALLGETAPI } from "../../api/apiHandler";

function __GETORDERHISTORYLATESTLIST(){
    const endpoint = _API_ENDPOINT.GET_ORDER_HISTORY_LATEST;
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID).toLowerCase();
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID).toLowerCase();
    const payload = {
        params: {
            'userId': UID,
            'deviceId':deviceId,
            'count':3
        }
    }
    return _CALLGETAPI(endpoint, payload)
    .then(response => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}
function* handleOrderHistoryLatestList(){
    try {
        const orderHistoryLatestList = 
        yield call(__GETORDERHISTORYLATESTLIST);
        (orderHistoryLatestList.actionStatus.toUpperCase() === SUCCESS)
        ? yield put(orderHistoryLatestServiceSuccess(orderHistoryLatestList))
        : yield* handleError(orderHistoryLatestServiceFailure, i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR"));
    } catch(error) {
        yield* handleError(orderHistoryLatestServiceFailure, error.message);
    }
}

export default function* watchFetchOrderHistoryLatestService() {
 yield takeLatest(orderHistoryLatestServiceInit.type, handleOrderHistoryLatestList)      
}